export const DAYS = ['days', 'day', 'd']
export const HOURS = ['hours', 'hour', 'h']
export const MINUTES = ['minutes', 'minute', 'm']
export const SECONDS = ['seconds', 'second', 's']
export const MILLISECONDS = ['millisecond', 'milliseconds', 'ms']